module.exports = '/ng-templates/commons/directives/jp-loading/jp-loading.tpl.ftl';
